import { Component, Input } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';
import { curveCardinal } from 'd3-shape';
import { SharedService } from 'src/app/services/shared.service';

@Component({
    selector: 'app-conv-blinks-chart',
    templateUrl: './conv-blinks-chart.component.html',
    styleUrl: './conv-blinks-chart.component.scss',
    standalone: false
})
export class ConvBlinksChartComponent {
	@Input() url_service!: string;

	@Input() blinksData: any[] = [];
	@Input() smoothedCog: any[] = [];
	@Input() smoothedEmo: any[] = [];

	chartData: any[] = [
		{ name: 'Engagment', series: [] }
	];

	selectedWindowTime: number = 5;
	submitted = false;
	errorMessage = '';

	curve: any = curveCardinal;

	legend = false;
  animations = false;
  showGridLines = true;
  roundDomains = true;
  xAxis = true;
  yAxis = true;
  showYAxisLabel = true;
  showXAxisLabel = true;
	colorScheme: string | Color = {
		name: 'myScheme',
		selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#15A607', '#F11C0A', '#F1D50A'],
  };

	ready = false;

	current_time = 0;
	lastBlinks = 0;
	min = 0;
	max = 100;

	constructor(private sharedService: SharedService) {}

	generate_new_data() {
		this.errorMessage = '';
		this.submitted = true;

		const check = this.selectedWindowTime && this.selectedWindowTime > 0 && this.selectedWindowTime <= 60;
		if (!check) {
			this.errorMessage = 'Window Time must be between 1 to 60';
			return;
		}

		this.ready = false;

		this.sharedService.getSmoothedRGBResults(this.url_service, { window_size_sec: this.selectedWindowTime }).subscribe({
			next: (data) => {
				this.smoothedCog = data.smoothed_cog;
				this.smoothedEmo = data.smoothed_emo;
				this.updateChart(this.current_time);
			},
			error: () => {
				this.errorMessage = 'Somthing went wrong, could not get the data';
			}
		});

	}

	calculateChartData(currentTime: number) {
		this.current_time = currentTime;
		const start = currentTime - 20;
		const dataChart: any = [
			{ name: 'Engagment', series: [] },
			{ name: 'Cognitive', series: [] },
			{ name: 'Emotion', series: [] },
		];

		for (let index = start; index <= currentTime; index++) {
			const time = this.convertToTimerFormat(index);

			let blinks;
			let cog;
			let emo;

			if (index < this.blinksData.length) {
				blinks = this.blinksData[index].blinks ? +this.blinksData[index].blinks.toFixed(2) : this.blinksData[index].blinks;
				this.lastBlinks = blinks;
			} else {
				blinks = this.lastBlinks;
			}

			if (index < this.smoothedCog.length) {
				cog = this.smoothedCog[index] ? +this.smoothedCog[index].toFixed(2) : this.smoothedCog[index];
				emo = this.smoothedEmo[index] ? +this.smoothedEmo[index].toFixed(2) : this.smoothedEmo[index];
			} else {
				cog = 0;
				emo = 0;
			}

			dataChart[0].series.push({ name: time, value: blinks });
			dataChart[1].series.push({ name: time, value: cog ? cog : 0 });
			dataChart[2].series.push({ name: time, value: emo ? emo : 0 });
		}

		this.chartData = [...dataChart];

		if (!this.ready) {
			this.ready = true;
		}
	}

	updateChart(currentTime: number) {
		if (currentTime > 20) {
			this.calculateChartData(currentTime);
		} else {
			this.calculateChartData(20);
		}
	}

	showChart() {
		this.ready = true;
		this.calculateChartData(20);
	}

	convertToTimerFormat(seconds: number) {
		if (seconds < 3600) {
			// Display "mm:ss" format for the first 60 minutes
			const minutes = Math.floor(seconds / 60);
			const formattedSeconds = (seconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			return `${formattedMinutes}:${formattedSeconds}`;
		} else {
			// After 60 minutes, switch to "hh:mm:ss" format
			const hours = Math.floor(seconds / 3600);
			const remainingSeconds = seconds % 3600;
			const minutes = Math.floor(remainingSeconds / 60);
			const formattedSeconds = (remainingSeconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			const formattedHours = hours.toString().padStart(2, "0");
			return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
		}
	}
}
